import { Box, Col, Colors, Ic3Dots, IcScreen, Row, StatusTag, Text } from 'basic-ui-lib';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { ScreenStatus, StatusScreenConfigs } from 'modules/dashboard/services/constants';
import styled from 'styled-components';

interface IScreenItemMobileProps {
  item: IScreen;
  onClickMenu?: () => void;
}

const ScreenItemMobile = ({ item, onClickMenu }: IScreenItemMobileProps) => {
  const config = StatusScreenConfigs[item.status as ScreenStatus];
  return (
    <Container>
      <Row flex={1}>
        <Box
          width={40}
          height={40}
          display='flex'
          justifyContent='center'
          alignItems='center'
          borderRadius={8}
          backgroundColor={Colors.neutral.bg[2]}
        >
          <IcScreen width={24} height={24} fill={Colors.neutral.bg[7]} />
        </Box>
        <Col gap={4}>
          <Text body_1 medium color='primary.6' left ellipsis lineClamp={1} style={{ maxWidth: 150 }}>
            {item.playerName}
          </Text>
          <Text caption_3 regular color='neutral.text.6' left>
            {item.businessName}
          </Text>
        </Col>
      </Row>
      <StatusTag backgroundColor={config?.backgroundColor} label={config?.label} color={config?.color} />
      <button onClick={() => onClickMenu?.()}>
        <Ic3Dots fill={Colors.neutral.bg[7]} />
      </button>
    </Container>
  );
};

export default ScreenItemMobile;

const Container = styled.div`
  display: flex;
  gap: 16px;
  padding: 8px;
  background-color: ${Colors.neutral.bg[1]};
  border-radius: 8px;
  border: 1px solid ${Colors.neutral.bg[5]};
  align-items: center;
`;
